<p-dialog [header]="userHeader" [modal]="true" [(visible)]="loadDialogView" [style]="{ width: '60rem' }"
    (onHide)="closeDialog(false)">
    <div class="user-details">
        <div class="alignment-center w-full">
            <form [formGroup]="userForm">
                <div class="card border-none px-0 py-2">
                    <div class="grid mb-3">
                        <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                            <div class="frm-label form-lbl">
                                <label for="firstName" class="font-semibold"
                                    translate>manage_users.user_form.first_name</label><span
                                    class="text-red-500 ml-1">*</span>
                            </div>
                            <div class="frm-control">
                                <input formControlName="firstName" class="full-width w-full custom-form" type="text"
                                    [placeholder]="'manage_users.user_form.first_name_placeholder' | translate" pInputText
                                    id="user-first-name" autocomplete="off"/>
                            </div>
                            @if (userForm.controls.firstName.errors && (userForm.controls.firstName.dirty ||
                            userForm.controls.firstName.touched)) {
                            <div class="form-errors">
                                <div [hidden]="!userForm.controls.firstName.errors.required" class="text-red-500" translate>
                                    manage_users.form_error.first_name_err
                                </div>
                                <div [hidden]="!userForm.controls.firstName.errors.pattern" class="text-red-500" translate>
                                    manage_users.form_error.firstname_pattern_err
                                </div>
                                @if (userForm.controls.firstName.errors.maxlength) {
                                <div class="text-red-500" translate>
                                    manage_users.form_error.firstname_max
                                </div>
                                }
                                @if (userForm.controls.firstName.errors.minlength) {
                                <div class="text-red-500" translate>
                                    manage_users.form_error.firstname_min
                                </div>
                                }
                            </div>
                            }
                        </div>
                        <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                            <div class="frm-label form-lbl">
                                <label for="lastName" class="font-semibold"
                                    translate>manage_users.user_form.last_name</label><span
                                    class="text-red-500 ml-1">*</span>
                            </div>
                            <div class="frm-control">
                                <input formControlName="lastName" class="full-width w-full custom-form" type="text"
                                    [placeholder]="'manage_users.user_form.last_name_placeholder' | translate" pInputText
                                    id="user-last-name" autocomplete="off"/>
                            </div>
                            @if (userForm.controls.lastName.errors && (userForm.controls.lastName.dirty ||
                            userForm.controls.lastName.touched)) {
                            <div class="form-errors">
                                <div [hidden]="!userForm.controls.lastName.errors.pattern" class="text-red-500" translate>
                                    manage_users.form_error.lastname_pattern_err
                                </div>
                                @if (userForm.controls.lastName.errors.maxlength) {
                                <div class="text-red-500" translate>
                                    manage_users.form_error.lastname_max
                                </div>
                                }
                                @if (userForm.controls.lastName.errors.minlength) {
                                <div class="text-red-500" translate>
                                    manage_users.form_error.lastname_min
                                </div>
                                }
                            </div>
                            }
                        </div>
    
    
                        <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                            <div class="frm-label form-lbl">
                                <label for="mobileNumber" class="font-semibold"
                                    translate>manage_users.user_form.mobile_number</label>
                            </div>
                            <div class="frm-control">
                                <div class="flex mobile-dropdown">
                                    <p-dropdown #dropdown (onChange)="selectCountry()" [options]="countries"
                                        [(ngModel)]="selectedCountry" [filter]="true" filterBy="value"
                                        (onFilter)="onFilter($event)" [ngModelOptions]="{standalone : true}"
                                        optionLabel="name" [showClear]="false">
                                        <ng-template pTemplate="selectedItem">
                                            @if(selectedCountry) {
                                            <div class="flex align-items-center gap-2">
                                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                                    [class]="'flag flag-' + selectedCountry?.code?.toLowerCase()"
                                                    class="width-18" />
                                                <div>{{ selectedCountry.value }}</div>
                                            </div>
                                            }
                                        </ng-template>
                                        <ng-template let-country pTemplate="item">
                                            <div class="flex align-items-center gap-2">
                                                <img src="https://primefaces.org/cdn/primeng/images/demo/flag/flag_placeholder.png"
                                                    [class]="'flag flag-' + country.code.toLowerCase()" class="width-18" />
                                                <div>{{ country.value }}</div>
                                            </div>
                                        </ng-template>
                                        <ng-template pTemplate="filtericon">
                                            <i [class]="filterIcon" (click)="onFilterIconClick()"></i>
                                        </ng-template>
                                    </p-dropdown>
                                    <input pInputText type="text" id="user-mobile" class="w-full input-mobile"
                                        (input)="selectCountry()" formControlName="contactNumber" pKeyFilter="int"
                                        [placeholder]="'manage_users.user_form.mobile_number_placeholder' | translate" />
                                </div>
                            </div>
                            @if (userForm.controls.contactNumber.errors && (userForm.controls.contactNumber.dirty ||
                            userForm.controls.contactNumber.touched)) {
                            <div class="form-errors">
                                @if(userForm.controls.contactNumber.errors?.required &&
                                (userForm.controls.contactNumber.dirty || userForm.controls.contactNumber.touched)){
                                <div [hidden]="!userForm.controls.contactNumber.errors.required" class="text-red-500"
                                    translate>
                                    manage_users.form_error.contact_required_err
                                </div>
                                }
                                @if (userForm.controls.contactNumber.errors.maxlength || userForm.controls.contactNumber.errors.pattern ||
                                userForm.controls.contactNumber.errors.minlength) {
                                <div class="text-red-500" translate>
                                    lbl_mobile_number_max_length
                                </div>
                                }
                            </div>
                            }
                        </div>
                        <div class="col-6 md:col-12 lg:col-6 flex flex-column gap-1 input-group">
                            <div class="frm-label form-lbl">
                                <label for="email" class="font-semibold"
                                    translate>manage_users.user_form.email_address</label><span
                                    class="text-red-500 ml-1">*</span>
                            </div>
                            <div class="frm-control">
                                <input formControlName="email" class="full-width w-full custom-form" type="text"
                                    [placeholder]="'manage_users.user_form.email_placeholder' | translate" pInputText
                                    id="user-email" autocomplete="off" />
                            </div>
                            @if (userForm.controls.email.errors && (userForm.controls.email.dirty ||
                            userForm.controls.email.touched)) {
                            <div class="form-errors">
                                <div [hidden]="!userForm.controls.email.errors.required" class="text-red-500" translate>
                                    manage_users.form_error.email_required_err
                                </div>
                                <div [hidden]="!userForm.controls.email.errors.pattern" class="text-red-500" translate>
                                    manage_users.form_error.email_pattern_err
                                </div>
                            </div>
                            }
                        </div>
    
                    </div>
                </div>
            </form>
        </div>
        <hr class="hr-line">
        <div class="flex save-button justify-content-end pb-3 mr-2">
            <button type="button" pButton [label]="'manage_users.lbl_cancel' | translate" (click)="closeDialog(false)"
                class="mr-20 border-none cancel-hover bg-transparent text-color height-44 border-button"
                id="cancelBtnId"></button>
    
            <button type="button" pButton id="saveBtnId"
                [label]="nextBtnLabel"
                (click)="onSaveUser()"
                class="height-44 save-add-hover"></button>
        </div>
    </div>
</p-dialog>

